import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useBasePath } from '../../../lib/use-base-path';
import { isPublicRoute } from '../../../lib/public-routes';
import { takePendingResume } from '../../../lib/profile-thread-target';

/**
 * Resumes a profile link a visitor tapped before they had an account (lib/profile-thread-target.ts): when
 * the sign-up lands them anywhere in the app other than `/profile-thread`, this sends them there once.
 * The record is consumed as the resume fires (`takePendingResume`), so it fires at most once — a failed
 * open never re-fires on every page — and a stale one expires on its own.
 *
 * Renders nothing. Mounted once, in `SymphonyApp`, on every route — public ones are skipped here, because a
 * stranger reading someone's card must never be pulled into a thread.
 */
export function PendingProfileThreadResume() {
  const router = useRouter();
  const basePath = useBasePath();
  useEffect(() => {
    if (!router.isReady || isPublicRoute(router.pathname)) return;
    const target = takePendingResume(router.pathname, Date.now());
    if (target) void router.replace(target, `${basePath}${target}`);
  }, [router, router.isReady, router.pathname, basePath]);
  return null;
}
